var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgSmartphoneOn = function SvgSmartphoneOn(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71429 3C7.45886 3 7 3.29754 7 4V20C7 20.7025 7.45886 21 7.71429 21H16.2857C16.5411 21 17 20.7025 17 20V14.5C17 13.9477 17.4477 13.5 18 13.5C18.5523 13.5 19 13.9477 19 14.5V20C19 21.5067 17.9238 23 16.2857 23H7.71429C6.07616 23 5 21.5067 5 20V4C5 2.49332 6.07616 1 7.71429 1H16.2857C17.9238 1 19 2.49332 19 4V5C19 5.55228 18.5523 6 18 6C17.4477 6 17 5.55228 17 5V4C17 3.29754 16.5411 3 16.2857 3H7.71429Z",
    fill: "#0D0E10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C10 17.4477 10.4477 17 11 17H13C13.5523 17 14 17.4477 14 18C14 18.5523 13.5523 19 13 19H11C10.4477 19 10 18.5523 10 18Z",
    fill: "#0D0E10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7007 4.28655C23.0947 4.67354 23.1004 5.30668 22.7134 5.70071L15.8384 12.7007C15.6504 12.8922 15.3933 13 15.125 13C14.8567 13 14.5996 12.8922 14.4116 12.7007L11.2866 9.51889C10.8996 9.12486 10.9053 8.49172 11.2993 8.10473C11.6933 7.71774 12.3265 7.72345 12.7134 8.11747L15.125 10.5729L21.2865 4.29929C21.6735 3.90527 22.3067 3.89956 22.7007 4.28655Z",
    fill: "#2298FE"
  })));
};
var Memo = /*#__PURE__*/memo(SvgSmartphoneOn);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/SmartphoneOn.2bd0b5121d5e3957f271faaf02e170d5.svg";